// extracted by mini-css-extract-plugin
module.exports = {"card":"deal-sync-sidebar-card_card__DNECl","header":"deal-sync-sidebar-card_header__gELi3"};